import { z } from 'zod'

export enum MedSummarySourceProvider {
  USER_FILES = 'user_files',
}

export const MedSummarySourceRefSchema = z.object({
  provider: z.literal(MedSummarySourceProvider.USER_FILES),
  source_id: z.string(),
  display_name: z.string(),
})

export type MedSummarySourceRef = z.infer<typeof MedSummarySourceRefSchema>
